







































































import Vue from 'vue';
import UserSetPasswordRequestViewModel from '../../../services/v1/viewModel/resource/UserSetPasswordRequestViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    resetPassword: new UserSetPasswordRequestViewModel(),
    requestError: undefined as any,
    newPasswordError: undefined as undefined | string,
    repeatPasswordError: undefined as undefined | string,
  }),
  computed: {
    user(): any {
      // TODO: Use proper User class once it is exported from core
      return this.$auth.user ?? {} as any;
    },
  },
  mounted() {
    this.$set(this.$store.values, 'title', 'USER PROFILE');
  },
  methods: {
    async doLogoff() {
      try {
        await this.$auth.logout();
        Vue.$router.push('/_exterior/login');
      } catch (error) {
        this.requestError = `${error}`;
      }
    },
    async doResetPassword() {
      try {
        this.newPasswordError = undefined;
        this.repeatPasswordError = undefined;
        this.resetPassword.email = this.user.email!;
        // TODO: - can be validated through control
        if (!this.resetPassword.newPassword || this.resetPassword.newPassword.length < this.$config.values['auth-min-password-length']) {
          this.newPasswordError = this.$t('core.validation.minLength', this.$config.values['auth-min-password-length']);
          return;
        }
        if (this.resetPassword.newPassword !== this.resetPassword.repeatNewPassword) {
          this.repeatPasswordError = this.$t('core.validation.sameAs');
          return;
        }

        await this.$service.api.core.me.setPassword(this.resetPassword)
          .then(() => {
            this.doLogoff();
          });
      } catch (error) {
        this.requestError = error;
      }
    },
  },
});
